import { useMemo } from 'react';
import type { RemindersStore } from '.';

export function useActiveReminders(store: RemindersStore) {
  return useMemo(
    () => store.state.list.filter((item) => !item.data.dismissed_at),
    [store.state.list],
  );
}

export function useUpcomingReminders(store: RemindersStore) {
  const dt = new Date();
  dt.setMinutes(0, 0, 0);
  const now = dt.toISOString();

  return useMemo(
    () => store.state.list.filter((item) => item.data.due_at >= now),
    [now, store.state.list],
  );
}
